(() => {
  const n = Number(window.theme?.settings?.accessWidgetScrollThreshold);
  const THRESHOLD = Number.isFinite(n) && n >= 0 ? n : 24; // 0 is a valid threshold

  let want = null; // last requested state — dedupes redundant scroll calls
  let resizeTimer = null;

  function apply(force) {
    const api = window.accessWidget;
    if (!api) return;
    const next = window.scrollY > THRESHOLD ? 'hide' : 'show';
    if (next === want && !force) return; // scroll path: only act on a transition
    want = next;
    if (next === 'hide') {
      if (api.hideWidgetInterface) api.hideWidgetInterface();
    } else if (api.showWidgetInterface) {
      api.showWidgetInterface();
    }
  }

  function onResize() {
    // accessiBe re-renders its trigger button (defaulting to visible) on resize,
    // which reverts our state with no scroll event to correct it. Force a
    // re-assert once the resize settles.
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => apply(true), 200);
  }

  // Run once accessiBe's interface is ready: its trigger button exists then, so
  // hide/show actually take effect (calling before render silently no-ops).
  window.accessWidgetOptions = window.accessWidgetOptions || {};
  const prevOnReady = window.accessWidgetOptions.onReady;
  window.accessWidgetOptions.onReady = function () {
    if (typeof prevOnReady === 'function') {
      try {
        prevOnReady();
      } catch (e) {}
    }
    window.addEventListener('scroll', () => apply(false), { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    apply(true);
  };
})();
